module.exports = __webpack_public_path__ + "img/global.86418600.png";